import RemittanceBaseService from './remittanceBaseService'

export default class RemittanceReportService extends RemittanceBaseService {
  async getCashCountReport(queryParams) {
    return await super.get(`report/transaction`, queryParams)
  }
}
